import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from '../src/pages/Home';
import LowonganKerja from './pages/Lowongan_kerja';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import DetailLowonganKerja from './pages/Detail_LowonganKerja';
import { DataProvider } from './context/DataProvider';
// import PrivateRoute from './router/PrivateRoute';
import RequireAuth from './router/RequireAuth';

function App() {
  return (
    <>
      <Router>
        <DataProvider>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/loker' element={<LowonganKerja />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/dashboard' element={<Dashboard />} />
            {/* <PrivateRoute  path='/detail-loker/:jobId' element={<DetailLowonganKerja />} roles={['member', 'admin']}/> */}
            {/* <Route path='/detail-loker/:jobId' element={<DetailLowonganKerja />} /> */}
            {/* <Route path='/detail-loker/:jobId' element={
              <PrivateRoute element={<DetailLowonganKerja />} roles={['member', 'admin']} />}
            /> */}
            {/* <Route
              path="/detail-loker/:jobId"
              element={<PrivateRoute element={<DetailLowonganKerja />} roles={['member', 'admin']} />}
            /> */}

            <Route path='/detail-loker/:jobId' element={
            

            <RequireAuth roles={['member','admin']}>
              <DetailLowonganKerja />
            </RequireAuth>
            
            } /> 
          </Routes>
        </DataProvider>
      </Router>
    </>
  )
}

export default App